import { LoaderFunctionArgs } from "react-router-dom";
import {
  getTableOfContents,
  TocEntry,
} from "../../../../common/api/decimal/methods/tableOfContents.ts";

export async function tableOfContentsDataLoader({
  params,
}: LoaderFunctionArgs): Promise<TocEntry[]> {
  const vbid = params.vbid;
  if (!vbid) {
    return [];
  }

  const result = await getTableOfContents(vbid);

  if (!result.ok || !result.data) {
    return [];
  }

  return result.data.items;
}
